<template>
  <!-- 转账内容 -->
  <div class="transfer">
    <form class="basic-form">
      <!-- 接收地址 -->
      <label>{{ $t("webwallet_to_address") }}</label>
      <input
        type="text"
        :placeholder="$t('webwallet_to_address_pl')"
        v-model="transfer.account"
        @input="dbDomain"
      />
      <ul class="basic-group clearfix">
        <li class="amount">
          <!-- 转账金额 -->
          <label>{{ $t("transfer_amount") }}</label>
          <input
            type="text"
            placeholder="0"
            v-model="transfer.amount"
            @input="dbDomain"
          />
        </li>
        <li class="token">
          <!-- Token -->
          <label>Token</label>
          <select v-model="transfer.token">
            <option
              v-for="(item, index) in tokensInfoList"
              :value="item.address"
              :key="index"
            >
              {{ item.symbol }}
            </option>
          </select>
        </li>
      </ul>
      <!-- 备注 -->
      <label>
        <i>{{ $t("webwallet_fee") }}</i>
        {{ (fee ? fee : "0") + " " + symbol }}
      </label>
      <a class="btn" v-if="!transferring" @click="sendTransfer">{{
        $t("transfer")
      }}</a>
      <button class="btn" v-else disabled="disabled">
        {{ $t("transferring") }}
      </button>
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ethers, utils } from "ethers";
import lodash from "lodash";
import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
import Eth from "@ledgerhq/hw-app-eth";

export default {
  data() {
    return {
      transfer: {
        account: "",
        amount: 0,
        token: "",
      },
      transferring: false,
      transferFee: [],
      fee: 0,
      ledgerFlag: false,
    };
  },
  created() {
    this.dbDomain = lodash.debounce(this.domain, 300);
  },
  computed: {
    ...mapGetters({
      tokensInfoList: "tokensInfoList",
    }),
  },
  methods: {
    // 将数量处理成16进制
    amountDeal(amount, decimals) {
      let bignumber = new this.BigNumber(amount);
      return "0x" + bignumber.times(Math.pow(10, decimals)).toString(16);
      // return bignumber.times(Math.pow(10, decimals)).toFixed();
    },
    compare() {
      return function (a, b) {
        if (b.symbol > a.symbol) {
          return -1;
        } else if (a.symbol > b.symbol) {
          return 1;
        }
        return 0;
      };
    },
    // 计算手续费
    async feeCompute() {
      if (
        this.transfer.account &&
        this.transfer.amount &&
        this.transfer.amount - 0 > 0 &&
        !this.transfer.account.includes(".")
      ) {
        try {
          let token = this.getTransferToken();
          let amount = this.amountDeal(this.transfer.amount, token.decimals);
          let address = this.webUtil.trimString(this.transfer.account);
          let gasLimit = await this.getGasLimit(
            this.account,
            address,
            token.address,
            amount
          );
          let gasPrice = await this.user.getGasPrice();
          this.fee = new this.BigNumber(gasLimit.toString())
            .times(gasPrice.toString())
            .div(Math.pow(10, this.decimal))
            .toFixed();
        } catch (e) {
          this.fee = 0;
        }
      } else {
        this.fee = 0;
      }
    },
    domain() {
      if (this.transfer.account && this.transfer.account.includes(".")) {
        let url =
          "https://a5.maiziqianbao.net/api/v1/tool/" +
          this.chainInfo.chainType +
          "/" +
          this.chainInfo.chainID +
          "/domain_resolver/" +
          this.transfer.account;
        this.axios.get(url).then((result) => {
          let data = result.data;
          if (!data.code) {
            let info = data.data ? data.data : null;
            if (info && info.type) {
              this.transfer.account = data.data.msg;
              this.feeCompute();
            }
          }
        });
      } else {
        this.feeCompute();
      }
    },
    getTransferToken() {
      let transferTokenInfo = this.tokensInfoList.filter((token) => {
        return token.address == this.transfer.token;
      });
      if (transferTokenInfo.length <= 0) {
        return false;
      }
      return transferTokenInfo[0];
    },
    // 获取gasLimit
    async getGasLimit(account, toAddress, contract = "", amount) {
      let params = {};
      if (this.transfer.token != "") {
        // erc20
        let addr = toAddress.slice(2).toLowerCase();
        params = {
          from: account,
          to: contract,
          data:
            "0x" +
            "a9059cbb" +
            "000000000000000000000000" +
            addr +
            "0000000000000000000000000000000000000000000000000000000000000001",
        };
      } else {
        // main token
        params = {
          from: account,
          to: toAddress,
          value: amount,
        };
      }
      return await this.user.estimateGas(params);
    },
    async sendTransfer() {
      let to = this.webUtil.trimString(this.transfer.account);
      if (!to) {
        return this.$toast(this.$t("transfer_account_null"));
      }
      if (!utils.isAddress(to)) {
        return this.$toast(this.$t("webwallet_to_valid_address"));
      }

      if (!this.transfer.amount) {
        return this.$toast(this.$t("transfer_amount_null"));
      }
      // 获取选择转账的token
      let token = this.getTransferToken();

      if (this.transfer.amount - 0 > token.balance - 0) {
        return this.$toast(this.$t("webwallet_amount_notenough"));
      }
      if (this.transfer.amount < Math.pow(10, -this.decimal)) {
        return this.$toast(
          this.$t("transfer_amount_min") + Math.pow(10, -this.decimal)
        );
      }

      this.transferring = true;
      let value = this.amountDeal(this.transfer.amount, token.decimals);
      let nonce = await this.user.getNonce(this.account);
      let gasPrice, gasLimit;
      try {
        gasPrice = await this.user.getGasPrice();
        gasLimit = await this.getGasLimit(
          this.account,
          to,
          token.address,
          value
        );
        gasLimit =
          "0x" +
          new this.BigNumber(gasLimit.toString()).toFixed(0).toString(16);
      } catch (e) {
        console.log(e.message);
      }
      let data = "";
      if (this.transfer.token != "") {
        // erc20
        let assets = utils.hexZeroPad(value, 32);
        data =
          "0x" +
          "a9059cbb" +
          "000000000000000000000000" +
          to.slice(2).toLowerCase() +
          assets.slice(2);
        to = token.address;
        value = "0x00";
      }
      let params = {
        from: this.account,
        to,
        value,
        data,
        chainId: this.chainInfo.chainID.toString(16),
      };
      if (gasPrice && gasLimit) {
        params.gasPrice = utils.hexlify(Number(gasPrice));
        params.gas = gasLimit;
      }
      this.ledgerFlag = JSON.parse(this.webUtil.getSession("ledger_flag"));
      try {
        if (this.ledgerFlag) {
          let unsignedTx = {
            to: params.to,
            gasLimit: params.gas,
            gasPrice: params.gasPrice,
            data: params.data,
            value: params.value,
            chainId: Number(params.chainId),
            nonce,
          };
          const serializedTx = utils.serializeTransaction(unsignedTx).slice(2);
          TransportWebUSB.create().then(async (transport) => {
            let eth = new Eth(transport);
            let { r, s, v } = await eth
              .signTransaction(this.path, serializedTx)
              .catch((e) => {
                this.$alert(e.message ? e.message : this.$t("transfer_fail"));
                this.transferring = false;
              });
            let signedTx = utils.serializeTransaction(unsignedTx, {
              v: ethers.BigNumber.from("0x" + v).toNumber(),
              r: "0x" + r,
              s: "0x" + s,
            });
            let res = await this.user.sendTransaction(signedTx);
            if (res.hash) {
              this.$alert(this.$t("submit_success")).then(() => {
                this.transferring = false;
                window.location.reload();
              });
            } else {
              this.transferring = false;
              this.$alert(this.$t("transfer_fail"));
            }
          });
        } else {
          this.webUtil
            .getEthereum()
            .then(async () => {
              let transactionHash = await window.ethereum.request({
                method: "eth_sendTransaction",
                params: [params],
              });
              if (transactionHash && Object.keys(transactionHash).length > 0) {
                this.$alert(this.$t("submit_success")).then(() => {
                  this.transferring = false;
                  window.location.reload();
                });
              } else {
                this.transferring = false;
                this.$alert(this.$t("transfer_fail"));
              }
            })
            .catch((e) => {
              this.$alert(e.message ? e.message : this.$t("transfer_fail"));
              this.transferring = false;
            });
        }
      } catch (e) {
        this.$alert(e.message ? e.message : this.$t("transfer_fail"));
        this.transferring = false;
      }
    },
  },
};
</script>
